import { canv } from '@/canv/global.js'
import { selectionManager } from '@/tools/cursorTool';

export class buildEvent {

    constructor() {

    }

    init(action, entitiesStates) {
        this.event = {
            "type": "build",
            "action": action,
            "entities": entitiesStates,
        };
    }

    execEvent() {
        if (this.event["action"] == "create") {
            let heads = canv.canvasController.createBranch(this.event["entities"]);
            for (let i = 0; i < heads.length; i++) {
                heads[i].collectNeedInitWidgets(canv.eventManager.needInitWidgets);
                let headParent = canv.canvasController.FindByUID(heads[i].parentUID);
                // есть entity.parentUID == "", то тут будет null и это ок
                heads[i].setParent(headParent);
                heads[i].addToCollection();

                if (!heads[i].isItemWrapper()) {
                    heads[i].children.forEach(child => {
                        child.addToCollection();
                    });
                }

                heads[i].fullUpdateDims();
            }

        } else {
            let UIDs = new Map();
            let states = this.event["entities"];

            // наполняем мапу UID
            for (let i = 0; i < states.length; i++) {
                UIDs.set(states[i]["UID"], 0);
            }

            let headGroups = [];

            for (let i = 0; i < states.length; i++) {
                let enitity = canv.canvasController.FindByUID(states[i]["UID"]); // в check уже проверили что есть
                if (!UIDs.has(enitity.parentUID)) {
                    headGroups.push(enitity);
                }
            }

            // тут кажется можно заменить на group.setParent(null).
            for (let i = 0; i < headGroups.length; i++) {
                let group = headGroups[i];

                if (this.event["action"] == "delete") {
                    group.beforeDeletion();
                }

                if (group.parent != null) {
                    for (let i = 0; i < group.parent.children.length; i++) {
                        if (group.parent.children[i] == group) {
                            group.parent.children.splice(i, 1);
                        }
                    }
                }

                if (group.isItemWrapper()) {
                    for (let i = 0; i < canv.canvasController.items.length; i++) {
                        if (canv.canvasController.items[i] == group) {
                            canv.canvasController.items.splice(i, 1);
                        }
                    }
                } else {
                    canv.canvasController.items = canv.canvasController.items.filter(g => {
                        return !group.children.some(child => child == g);
                    });

                    canv.canvasController.groups.delete(group.UID);
                }

                if (canv.canvasController.isInSelectedDeep(group)) {
                    // Делаем так, чтобы внутри softResetMode не сохранить interaction для уже удаленного entity
                    canv.toolBox.TryGetToolByName("cursorTool").mode = "";
                    selectionManager.clearSelected();
                }
            }
        }
    }

    checkEvent() {

        if (this.event["action"] == "delete") {
            let UIDs = new Map();

            for (let i = 0; i < this.event["entities"].length; i++) {
                UIDs.set(this.event["entities"][i]["UID"], 0);
                let enitity = canv.canvasController.FindByUID(this.event["entities"][i]["UID"]);
                if (enitity == null) {
                    return false;
                }
            }


            // проверяем, что не останется нерабочих ссылок
            for (let i = 0; i < this.event["entities"].length; i++) {

                let entity = canv.canvasController.FindByUID(this.event["entities"][i]["UID"]);
                if (!entity.checkDeletion(UIDs)) {
                    return false;
                }
            }
        } else {
            for (let i = 0; i < this.event["entities"].length; i++) {
                let enitity = canv.canvasController.FindByUID(this.event["entities"][i]["UID"]);
                if (enitity != null) {
                    return false;
                }
            }
        }

        return true;
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event) {
        this.event = event;
    }

    getTwin() {


        let action = "create";
        // заново собираем entity потому что у них может быть например другой parentUID
        let enitites = [];

        if (this.event["action"] == "create") {
            action = "delete";
            enitites = this.event["entities"];
        } else {
            for (let i = 0; i < this.event["entities"].length; i++) {
                let enitity = canv.canvasController.FindByUID(this.event["entities"][i]["UID"]);
                enitites.push(enitity.getState("full"));
            }
        }


        let twin = new buildEvent();
        twin.init(action, enitites);

        return twin;
    }





    event = {};


}
